<template>
  <div>
    <h2 style="text-align: center; color: #655F49; margin: 5em;">Il semblerait que vous soyez perdus...</h2>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
